import { Outlet } from 'react-router-dom'
import { AuthProvider } from '@/components/auth/AuthProvider'

/** Root layout — wraps all routes with AuthProvider so it lives inside RouterContext. */
export function RootLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  )
}
